import { BLOCK_SECONDS, formatUsdPerHour, type PriceCoin } from '../core/pricing'

/**
 * A rate a tenant pays, in dollars per hour.
 *
 * Chain prices are integers per block, which is the wrong unit to put in front
 * of someone deciding what to rent: a per-block figure is unreadable and a
 * DDT figure asks them to learn a token before they can read a price. The
 * conversion is exact — `1 DDT = $1.00 = 1,000,000 uddt` — so nothing is lost
 * by showing the useful unit.
 *
 * A price that cannot be converted exactly renders as unavailable rather than
 * as `$0.00/hour`, which would be a confident wrong number.
 */
export function Rate({
  coin,
  blockSeconds,
  fallback = 'Unavailable',
}: {
  coin: PriceCoin | null | undefined
  blockSeconds?: number | undefined
  fallback?: string | undefined
}) {
  const text = formatUsdPerHour(coin, blockSeconds ?? BLOCK_SECONDS)
  if (text === null) return <span className="muted">{fallback}</span>
  return <span className="money">{text}</span>
}
